"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var common_1 = require("../helpers/geoChart/common");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
function PushpinSizeLegend(props) {
    var _a = props.sizes, sizes = _a === void 0 ? [] : _a, format = props.format, _b = props.numericSymbols, numericSymbols = _b === void 0 ? [] : _b, measureName = props.measureName, isSmall = props.isSmall, showMiddleCircle = props.showMiddleCircle;
    var sizeData = getSizeData(sizes);
    if (!sizeData.length) {
        return null;
    }
    var min = getMin(sizeData);
    var max = getMax(sizeData);
    if (min === max) {
        return null;
    }
    var diff = max - min;
    var classNamesContainer = classnames_1["default"]("pushpin-size-legend s-pushpin-size-legend", {
        "is-small-container": isSmall
    });
    var classNamesCircles = classnames_1["default"]("pushpin-size-legend-circle-list", { "is-small-circles": isSmall });
    return (react_1["default"].createElement("div", { className: classNamesContainer },
        measureName ? (react_1["default"].createElement("div", { className: "metric-name", title: measureName },
            measureName,
            ":")) : null,
        react_1["default"].createElement("div", { className: classNamesCircles },
            react_1["default"].createElement("div", { className: "pushpin-size-legend-circle circle-min-value" },
                react_1["default"].createElement("span", { className: "circle-min-icon" }),
                react_1["default"].createElement("span", { className: "circle-value" }, sdk_ui_vis_commons_1.formatLegendLabel(min, format, diff, numericSymbols))),
            showMiddleCircle ? renderMiddleCircle(props) : null,
            !measureName ? react_1["default"].createElement("div", { className: "circle-separator" }) : null,
            react_1["default"].createElement("div", { className: "pushpin-size-legend-circle circle-max-value" },
                react_1["default"].createElement("span", { className: "circle-max-icon" }),
                react_1["default"].createElement("span", { className: "circle-value" }, sdk_ui_vis_commons_1.formatLegendLabel(max, format, diff, numericSymbols))))));
}
exports["default"] = PushpinSizeLegend;
function renderMiddleCircle(props) {
    var _a = props.sizes, sizes = _a === void 0 ? [] : _a, format = props.format, _b = props.numericSymbols, numericSymbols = _b === void 0 ? [] : _b, measureName = props.measureName;
    var sizeData = getSizeData(sizes);
    var diff = getMax(sizeData) - getMin(sizeData);
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        !measureName && react_1["default"].createElement("div", { className: "circle-separator" }),
        react_1["default"].createElement("div", { className: "pushpin-size-legend-circle circle-average-value" },
            react_1["default"].createElement("span", { className: "circle-average-icon" }),
            react_1["default"].createElement("span", { className: "circle-value" }, sdk_ui_vis_commons_1.formatLegendLabel(common_1.calculateAverage(sizeData), format, diff, numericSymbols)))));
}
function getSizeData(sizes) {
    return sizes.filter(function (value) { return value !== null && isFinite && !isNaN(value); });
}
function getMin(sizeData) {
    return Math.min.apply(Math, sizeData);
}
function getMax(sizeData) {
    return Math.max.apply(Math, sizeData);
}
//# sourceMappingURL=PushpinSizeLegend.js.map